import { createContext } from 'react';

export const navBarContext = createContext({});
export const NavBarContextProvider = navBarContext.Provider;
export const NavBarContextConsumer = navBarContext.Consumer;
